import script from "./UserRead.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRead.vue?vue&type=script&setup=true&lang=js"

import "./UserRead.vue?vue&type=style&index=0&id=7f0d5efa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f0d5efa"]])

export default __exports__